import { useAccessControl } from "@/hooks/useAccessControl";
import { AppLayout } from "@/components/layout/AppLayout";
import { PageHeader } from "@/components/layout/PageHeader";
import { PageContainer } from "@/components/layout/PageContainer";
import { Card } from "@/components/ui/card";

const EmailTemplatesSettingsPage = () => {
  const { isTenantAdmin } = useAccessControl();

  if (!isTenantAdmin) {
    return (
      <AppLayout>
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold mb-4">Access Denied</h2>
            <p className="text-gray-600">You need Tenant Admin permissions to access this page.</p>
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <PageContainer>
        <PageHeader
          title="Email Templates"
          description="Customize automated email templates for notifications and communication."
          breadcrumbItems={[{ label: "Setup", href: "/setup" }, { label: "Email Templates" }]}
          showSearch={false}
          titleSize="md"
        />

        <Card className="p-6">
          <p className="text-gray-600">
            Email templates configuration page coming soon. This will allow you to customize
            automated email templates for notifications and communication.
          </p>
        </Card>
      </PageContainer>
    </AppLayout>
  );
};

export default EmailTemplatesSettingsPage;
